/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RootService {

    /**
     * Hello World
     * @returns any Successful Response
     * @throws ApiError
     */
    public static helloWorld(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/',
        });
    }

    /**
     * Read Main
     * @returns any Successful Response
     * @throws ApiError
     */
    public static readMain(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/app',
        });
    }

    /**
     * Read Root
     * @returns any Successful Response
     * @throws ApiError
     */
    public static readRoot(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/version',
        });
    }

}
